export const KNOWLEDGE_BASE = {
  PROTECTION:
    'https://knowledge-base.yieldbird.com/prebid-stack/url-filtering#block-af56e726f86d4c67b0409aee4ec1093a',
} as const
